// Store test sayfasi - Context API store'un calistigini dogrular
import { useAppStore } from '../store'

export default function StoreTest() {
  const {
    // Auth state
    user, token, isAuthenticated, login, logout,
    // Theme state
    theme, toggleTheme,
    // UI state
    sidebarCollapsed, toggleSidebar, notifications,
  } = useAppStore()

  // Test login fonksiyonu
  function handleTestLogin() {
    const testUser = {
      id: 1,
      username: 'test_user',
      display_name: 'Test User',
      email: 'test@example.com',
      role: 'both' as const,
      level: 5,
      xp: 1250,
      reputation: 850,
      wallet_balance: 500,
      created_at: new Date().toISOString(),
    }
    login('test_token_12345', testUser)
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'system-ui' }}>
      <h1>Context API Store Test</h1>

      {/* Auth State Test */}
      <section style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>
        <h2>Auth State</h2>
        <p><strong>Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
        <p><strong>Token:</strong> {token || 'null'}</p>
        <p><strong>User:</strong> {user ? user.username : 'null'}</p>
        <div style={{ marginTop: '10px' }}>
          {!isAuthenticated ? (
            <button onClick={handleTestLogin} style={{ padding: '8px 16px', cursor: 'pointer' }}>
              Test Login
            </button>
          ) : (
            <button onClick={logout} style={{ padding: '8px 16px', cursor: 'pointer' }}>
              Logout
            </button>
          )}
        </div>
      </section>

      {/* Theme State Test */}
      <section style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>
        <h2>Theme State</h2>
        <p><strong>Current Theme:</strong> {theme}</p>
        <button onClick={toggleTheme} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          Toggle Theme
        </button>
      </section>

      {/* UI State Test */}
      <section style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>
        <h2>UI State</h2>
        <p><strong>Sidebar Collapsed:</strong> {sidebarCollapsed ? 'Yes' : 'No'}</p>
        <p><strong>Notifications Count:</strong> {notifications.length}</p>
        <button onClick={toggleSidebar} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          Toggle Sidebar
        </button>
      </section>

      {/* LocalStorage Test */}
      <section style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>
        <h2>LocalStorage Persistence</h2>
        <p><strong>session_token:</strong> {localStorage.getItem('session_token') || 'null'}</p>
        <p><strong>theme:</strong> {localStorage.getItem('theme') || 'null'}</p>
        <p><strong>user_data:</strong> {localStorage.getItem('user_data') ? 'exists' : 'null'}</p>
      </section>
    </div>
  )
}
